import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type documentApprovalState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: [];
  filterSearchData: any[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  documentApprovalDetail: object;
  success: boolean;
};

const initialState: documentApprovalState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  documentApprovalDetail: {},
  success: false,
};

export const documentApprovalSlice = createSlice({
  name: 'documentApproval',
  initialState,
  reducers: {
    filterDocumentApproval: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    filterDocumentApprovalSuccess: (state, action) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload.records;
      state.filterSearchData = action.payload.records;
      state.filterSearchTotal = action.payload.total;
      if (!state.filterSearchTotal) {
        state.message = i18n.t('message.common.0001');
      }
      state.success = false;
    },
    filterDocumentApprovalFailure: (state) => {
      state.loading = false;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    updateDocumentApproval: (state, action) => {
      state.loading = true;
      state.success = false;
    },
    updateDocumentApprovalSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateDocumentApprovalFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    cleanDataDocumentApproval: (state) => {
      state.documentApprovalDetail = {};
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterDocumentApproval,
  filterDocumentApprovalSuccess,
  filterDocumentApprovalFailure,
  setLoadingExportExcel,
  updateDocumentApproval,
  updateDocumentApprovalSuccess,
  updateDocumentApprovalFailure,
  cleanDataDocumentApproval,
  cleanData,
} = documentApprovalSlice.actions;

export default documentApprovalSlice.reducer;
